import { IKnmViolationType } from 'APIPackage/CatalogsModule/interfaces/IKnmViolationType';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

export async function fetchKnmViolationTypesAll(): Promise<IKnmViolationType[]> {
  return apiGet<IKnmViolationType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-violation-types/all`,
  );
}

export async function createKnmViolationType(knmViolationType: Omit<IKnmViolationType, 'id'>): Promise<void> {
  return apiPost<void>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-violation-types`,
    body: knmViolationType,
  });
}

export async function updateKnmViolationType(knmViolationType: IKnmViolationType): Promise<void> {
  const { id, ...data } = knmViolationType;

  return apiPut<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-violation-types/${id}`, data);
}
